import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=23c572de&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=23c572de&prod&scoped=true&lang=css"
import style1 from "./Search.vue?vue&type=style&index=1&id=23c572de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c572de",
  null
  
)

export default component.exports